import { Box, Container } from '@mui/material'
import { Loader, useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useYardStores } from '../../AppProvider'
import { PiersHeader } from './components/molecules/PiersHeader'
import { PierTable } from './components/organisms/PierTable'

export const PiersPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { pierStore } = useYardStores()

    const { loading } = useAsyncFetch(async () => await pierStore.loadPiers(), [pierStore])

    if (loading) return <Loader show />

    return (
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100%' }}>
        <PiersHeader />
        <Container sx={{ paddingY: theme.customSpacing.m }} data-cy='pier-table'>
          <PierTable store={pierStore} />
        </Container>
      </Box>
    )
  }),
)
